import React, { Component } from "react"
import styled from "styled-components"
import { motion } from "framer-motion"
import Button from "../Button/button"


const data = [
  {
    title: "Learn the basics of programming",
    description:
      "We begin by introducing students to the fundamental concepts that are used in every programming language. Concepts such as loops, functions, conditionals and more!",
  },
  {
    title: "Constant collaboration",
    description:
      "Kids meet with other like minded students, and together they’re able to solve problems using code. School encourages students to speak their mind, ask questions and solve problems. We do the same!",
  },
  {
    title: "Creativity is the limit",
    description:
      "Whatever your passion is, whether it is drawing, doing math and sciences, you can inject that into your code. Let your creativity run wild. After all, creativity is intelligence having fun :)",
  },
]

const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;

  @media (min-width: 748px) {
  }
`

const Title = styled.h2`
  font-family: Poppins-Bold, sans-serif;
  font-size: 2rem;
  text-align: center;
  padding-top: 32px;
  margin-bottom: 32px;
  padding-left: 16px;
  padding-right: 16px;

  @media (min-width: 768px) {
    font-size: 4rem;
    padding-left: 0;
    padding-right: 0;
    max-width: 880px;
  }
`

const PricingBox = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  flex-wrap: wrap;
  padding: 8px;
  text-align: center;
  @media (min-width: 748px) {
    flex-direction: row;
  }
`

const PricingCard = styled.div`
  width: 314px;
  position: relative;
  word-wrap: break-word;
    background-color: #fff;
    background-clip: border-box;
    box-shadow: 0 4px 24px 0 rgba(0,0,0,.08);
    border-radius: 28px;
  padding-bottom: 32px;
  margin-left: auto;
  margin-right: auto;
  margin-top: 16px;
  @media (min-width: 748px) {
    width: 384px;
  margin: 8px;

  }
  
`

const PriceBox = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  height: 100px;
  margin: 24px;
  margin-bottom: 12px;
  @media (min-width: 768px) {
     margin: 32px;
  }
`

const Cost = styled.p`
  color: #5225ee;
  font-size: 72px;
  font-family: Poppins-Bold, sans-serif;
  line-height: 1;
  

  em {
    font-size: 32px;
    font-style: normal;
    position: relative;
    top: -26px;
  }

  span {
    font-size: 32px;
    margin-left: -4px;
    opacity: 0.5;
  }
`

const Special = styled.div`
  margin: 0 auto;
  max-width: 250px;

  em {
    color: #5225ee;
    font-style: normal;
  }
`

const PriceBody = styled.div`
    font-size: 1.1rem;
    font-family: Poppins;
    padding: 0px 24px 0;
  border-top: 1px solid rgba(14,21,64,.08);
  @media (min-width: 748px) {
    padding: 0px 32px 0;

  }
`

const Features = styled.ul`
    list-style: none;
    text-align: left;
    margin-bottom: 32px;
    padding: 0;
    margin-top: 32px;
    margin-left: 16px;

    @media (min-width: 768px) {
        margin-left: 32px;
    }       

    li { 
        display: flex;
        justify-content: flex-start;
    }

    p:last-child {
        width: 240px;
    }
 
`

const Feature = styled.li`
    margin-bottom: 0.5rem;
    padding-bottom: 1rem;
    line-height: 1.5;

    p {
        text-align: left;
        margin: 0;
        display: inline-block;
    }


`

export default class extends Component {
  render() {
    return (
      <motion.div
        initial="hidden"
        animate="visible"
        variants={{
          visible: { opacity: 1, y: 0 },
          hidden: { opacity: 0, y: 20 },
        }}
        transition={{ ease: "easeOut", duration: 0.8, delay: 1.5 }}
      >
        <Container>
          <Title>You encourage them, Codehall will teach them</Title>

          <PricingBox>
            <PricingCard>
              <PriceBox>
                <Cost>
                  <em>$</em>50<span>/wk</span>
                </Cost>
                {/* <Special>
                  <em>$175/mo</em>&nbsp;per&nbsp;<span>additional</span>
                  &nbsp;child
                </Special> */}
              </PriceBox>
              <PriceBody>
                <Features>
                  <Feature>✅&nbsp;&nbsp;<p>Weekly Sessions</p></Feature>
                  <Feature>✅&nbsp;&nbsp;<p>100s Of Coding Activities</p></Feature>
                  <Feature>✅&nbsp;&nbsp;<p>Rewards&nbsp;Competitions</p></Feature>
                  <Feature>✅&nbsp;&nbsp;<p>Coding Platform</p></Feature>
                  <Feature>✅&nbsp;&nbsp;<p>No commitments, cancel any time!</p></Feature>

                
                </Features>
              </PriceBody>
              <Button label="Get Your Free Trial" cta="Get Your Free Trial" anchor={true} href="https://form.jotform.com/202457215984258"></Button>

            </PricingCard>
            <PricingCard>
              <PriceBox>
                <Cost>
                  <em>$</em>200<span>/mo</span>
                </Cost>
                {/* <Special>
                  <em>$175/mo</em>&nbsp;per&nbsp;<span>additional</span>
                  &nbsp;child
                </Special> */}
              </PriceBox>
              <PriceBody>
                <Features>
                  <Feature>✅&nbsp;&nbsp;<p>Weekly Sessions</p></Feature>
                  <Feature>✅&nbsp;&nbsp;<p>100s Of Coding Activities</p></Feature>
                  <Feature>✅&nbsp;&nbsp;<p>Rewards&nbsp;Competitions</p></Feature>
                  <Feature>✅&nbsp;&nbsp;<p>Coding Platform</p></Feature>
                  <Feature>✅&nbsp;&nbsp;<p>No commitments, cancel any time!</p></Feature>

                
                </Features>
              </PriceBody>
              <Button label="Get Your Free Trial" cta="Get Your Free Trial" anchor={true} href="https://form.jotform.com/202457215984258"></Button>

            </PricingCard>
          </PricingBox>
        </Container>
      </motion.div>
    )
  }
}
